module.exports = __webpack_public_path__ + "static/4-2d96cb5074839f83176acaff48cc4d99.svg";